export {createResource} from './GenericResourceFactory'
